import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Calendar, Tag, User } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { api } from "../lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setErr(true));
  }, [slug]);

  const fmt = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1">
        {err ? (
          <div className="max-w-[760px] mx-auto px-5 py-24 text-center">
            <h1 className="font-head text-2xl font-bold text-[#16244F]">Article not found</h1>
            <button onClick={() => navigate("/blog")} className="mt-5 text-[#F58220] font-head font-semibold">Back to Blog</button>
          </div>
        ) : !post ? (
          <div className="max-w-[760px] mx-auto px-5 py-24 text-center text-[#5a6274]">Loading...</div>
        ) : (
          <article className="max-w-[800px] mx-auto px-5 py-12 md:py-16">
            <button onClick={() => navigate("/blog")} className="inline-flex items-center gap-1.5 text-[#5a6274] hover:text-[#16244F] font-head text-sm mb-6">
              <ArrowLeft size={16} /> All Articles
            </button>
            <div className="flex flex-wrap items-center gap-4 text-sm text-[#8a90a0] mb-4">
              <span className="inline-flex items-center gap-1 text-[#2b8cf0] font-semibold"><Tag size={14} /> {post.category}</span>
              <span className="inline-flex items-center gap-1"><Calendar size={14} /> {fmt(post.published_at)}</span>
              <span className="inline-flex items-center gap-1"><User size={14} /> {post.author}</span>
            </div>
            <h1 className="font-head text-3xl md:text-4xl font-bold text-[#16244F] leading-tight">{post.title}</h1>
            {post.cover_image && (
              <img src={post.cover_image} alt={post.title} className="w-full h-[320px] md:h-[420px] object-cover rounded-2xl mt-8 cc-shadow-card" />
            )}
            <div className="mt-8 prose max-w-none">
              {post.content.split("\n").filter(Boolean).map((para, i) => (
                <p key={i} className="text-[17px] leading-8 text-[#45506b] mb-5">{para}</p>
              ))}
            </div>
            <div className="mt-12 rounded-2xl bg-[#eaf3ff] p-7 text-center">
              <h3 className="font-head text-xl font-bold text-[#16244F]">Need personalised guidance?</h3>
              <p className="text-[#5a6274] mt-2">Book a free career counselling session with our experts.</p>
              <button onClick={() => navigate("/", { state: { scrollTo: "contact" } })} className="mt-5 inline-flex items-center gap-2 bg-[#F58220] hover:bg-[#e0730f] text-white font-head font-semibold px-6 py-3 rounded-lg transition-colors">
                Book an Appointment
              </button>
            </div>
          </article>
        )}
      </main>
      <Footer />
    </div>
  );
}
